import { AlertCircle } from 'lucide-react';

import type { APPostingError } from '@schemas/api';

interface APPostingErrorAlertProps {
  error?: APPostingError | null;
  compact?: boolean;
}

export function APPostingErrorAlert({ error, compact = false }: APPostingErrorAlertProps) {
  if (!error) {
    return null;
  }

  const detail = error.detail && error.detail !== error.message ? error.detail : null;

  return (
    <div
      role="alert"
      className={`flex items-start gap-2 border-red-200 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950/40 dark:text-red-100 ${
        compact ? 'border-y px-4 py-2 text-xs' : 'rounded-lg border p-4 text-sm'
      }`}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-semibold">ERP posting failed</p>
        <p className="mt-0.5 whitespace-pre-line break-words">{error.message}</p>
        {detail ? (
          <p className="mt-1 whitespace-pre-line break-words opacity-90">{detail}</p>
        ) : null}
        <p className="mt-1 opacity-80">
          {error.retryable
            ? 'The system may retry automatically. Review the posting if the error remains.'
            : 'Review the ERP account, item, and tax selections before trying again.'}
          {error.code ? ` Error code: ${error.code}.` : ''}
        </p>
      </div>
    </div>
  );
}
